import { render } from "./CrPage.vue?vue&type=template&id=ede3c41c&scoped=true"
import script from "./CrPage.vue?vue&type=script&lang=js"
export * from "./CrPage.vue?vue&type=script&lang=js"

import "./CrPage.vue?vue&type=style&index=0&id=ede3c41c&scoped=true&lang=scss"

import exportComponent from "/home/forge/pga-beta.devserver6.com/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ede3c41c"]])

export default __exports__